import React from "react";

const UserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 100 100"
      width={25}
      height={25}
    >
      <path d="M65.904,52.834c-4.734,3.725-10.695,5.955-17.172,5.955c-6.316,0-12.146-2.119-16.821-5.68C16.654,55.575,5,68.803,5,84.757  c0,17.711,14.356,6.197,32.065,6.197h25.868C80.643,90.954,95,102.468,95,84.757C95,68.051,82.22,54.333,65.904,52.834z" />
      <path d="m48.732 55.057c13.285 0 24.092-10.809 24.092-24.095 0-13.285-10.807-24.094-24.092-24.094s-24.093 10.809-24.093 24.094c1e-3 13.286 10.809 24.095 24.093 24.095z" />
    </svg>
  );
};

export default UserIcon;
